export const styles = {
  container: {
    px: { base: '10', md: '20' },
  },
};
